/** Types de tâche planning équipe — alignés sur l’API (EquipePlanningTask). */
export const PLANNING_TASK_TYPES = ['trois_d', 'modifs', 'plan_fab', 'plan_technique', 'plan_montage_prod', 'maquette', 'projet', 'pao', 'bat', 'note'];

export const PLANNING_TASK_TYPE_LABELS = {
    projet: 'VDC',
    trois_d: '3D',
    modifs: 'MODIF',
    maquette: 'DDP',
    plan_fab: 'Plan de fab',
    plan_technique: 'Plan technique',
    plan_montage_prod: 'Plan de montage et prod',
    pao: 'PAO',
    bat: 'BAT',
    note: 'Note',
};

/** Priorités — alignées sur l’API (EquipePlanningTask::PRIORITES). */
export const PLANNING_TASK_PRIORITIES = ['urgent', 'elevee', 'normale', 'basse'];

export const PLANNING_TASK_PRIORITY_LABELS = {
    urgent: 'Urgent',
    elevee: 'Élevée',
    normale: 'Normale',
    basse: 'Basse',
};

/** Poids pour le tri : plus petit = plus prioritaire. */
export const PLANNING_TASK_PRIORITY_ORDER = {
    urgent: 0,
    elevee: 1,
    normale: 2,
    basse: 3,
};

/** Avancement déclaré par l'assigné — aligné sur l'API (EquipePlanningTask::STATUTS_AVANCEMENT). */
export const PLANNING_TASK_STATUTS = ['a_faire', 'en_cours', 'terminee', 'en_retard'];

export const PLANNING_TASK_STATUT_LABELS = {
    a_faire: 'À faire',
    en_cours: 'En cours',
    terminee: 'Terminée',
    en_retard: 'En retard',
};
